(function (jQuery, Drupal) {
  'use strict';
  var once = true;
  Drupal.behaviors.menus = {
    attach: function (context, settings) {
      if (once) {
        once = false;
        var $header = jQuery('header');
        var $burger = $header.find('.hamburger');
        var $headerMenus = $header.find('.menus');

        if (!Modernizr.touch) {
          $header.addClass('notouch');
        }
        $burger.click(function () {
          $headerMenus.toggleClass('active');
          $burger.toggleClass('is-active');
        });

        var $languageMenu = $headerMenus.find('.block-language-switcher');
        $languageMenu.click(function (event) {
          var $target = jQuery(event.target);
          if ($target.hasClass('is-active')) {
            event.preventDefault();
          }
          $languageMenu.toggleClass('active');
        });

        var $navigationMenu = $headerMenus.find('#block-mainnavigation');
        if (Modernizr.touch || jQuery(window).width() < 1280) {
          $navigationMenu.find('> ul > li.menu-item')
            .click(function (event) {
              var $currentTarget = jQuery(event.currentTarget);
              if ($currentTarget.hasClass('menu-item--expanded')) {
                if (!$currentTarget.hasClass('active')) {
                  event.preventDefault();
                  $navigationMenu.find('li.menu-item.menu-item--expanded')
                    .removeClass('active');
                  $currentTarget.addClass('active');
                  $currentTarget.prepend('<span class="back">' + Drupal.t('Retour') + '</span>');
                  $currentTarget.find('.back').click(function(event) {
                    event.stopPropagation();
                    $navigationMenu.find('li.menu-item.menu-item--expanded')
                    .removeClass('active');
                    $currentTarget.find('.back').remove();
                  });
                }
              }
            });
        } else {
          $navigationMenu.find('> ul > li.menu-item')
            .mouseenter(function (event) {
              var $currentTarget = jQuery(event.currentTarget);
              if ($currentTarget.hasClass('menu-item--expanded')) {
                if (!$currentTarget.hasClass('active')) {
                  $navigationMenu.find('li.menu-item.menu-item--expanded')
                    .removeClass('active');
                  $currentTarget.addClass('active');
                }
              }
              else {
                $navigationMenu.find('li.menu-item.menu-item--expanded')
                  .removeClass('active');
              }
            });
          jQuery('main[role="main"]').hover(function (event) {
            $navigationMenu.find('li.menu-item.menu-item--expanded')
              .removeClass('active');
          });
        }
      }
    }
  };

})(jQuery, Drupal);
